import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { useAppBranding } from '../../config/branding';
import config from '../../config/config';
import { useBranding } from '../../context/BrandingContext';
import MyButton from '../../shared-components/button/button';
import Footer from '../../shared-components/Footer/Footer';
import LanguageSelector from '../../shared-components/LanguageSelector/LanguageSelector';
import ToastMessage from '../../shared-components/toast-message/ToastMessage';
import getFirstSubdomain from '../../shared-functions/DomiansplitFunction';
import { setLocalStorageItem } from '../../shared-functions/LocalStorage';

/**
 * Component to redirect with device id
 * @returns
 */
export default function index() {
  const { t } = useTranslation('redirect');
  const { brandData } = useBranding();
  const [searchParameters] = useSearchParams();
  const deviceId = searchParameters.get('deviceId');
  const navigate = useNavigate();
  const [toastStatus, setToastStatus] = useState({
    openToast: false,
    showToastMessage: '',
  });
  const [appVersion, setAppVersion] = useState<string>('');
  const { images: brandImage } = useAppBranding();

  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  const domainParameter = queryParameters.get('domain');
  const cachedLocal = JSON.parse(
    localStorage.getItem(`dynamicBranding_${domainParameter}`) || ('{}' as any),
  );

  useEffect(() => {
    if (domainParameter) {
      setLocalStorageItem('domain', domainParameter);
    } else {
      localStorage.removeItem('domain'); // ✅ remove when not present
    }
  }, [domainParameter]);
  /**
   * Function routing to pay path
   */
  const handleRoute = () => {
    if (deviceId) {
      navigate(`/pay/${deviceId}${domainParameter ? `?domain=${domainParameter}` : ''}`);
    } else {
      setToastStatus({
        openToast: true,
        showToastMessage: t('toastDeviceNotFound'),
      });
    }
  };

  /**
   * handleVersion fetches the current app version from version.txt
   */
  const handleVersion = async () => {
    try {
      // ✅ Automatically pick current domain
      const baseUrl = window.location.origin;
      const url = `${baseUrl}/version.txt`;

      const response = await fetch(url, {
        method: 'GET',
        cache: 'no-cache',
      });
      if (!response.ok) {
        setAppVersion('');
        return;
      }

      const contentType = response.headers.get('content-type');

      // ✅ Ensure it's plain text, not HTML
      if (!contentType || !contentType.includes('text/plain')) {
        setAppVersion('');
        return;
      }

      const text = await response.text();

      // ❗ Avoid HTML error response
      if (!text || text.includes('<!DOCTYPE html>')) {
        setAppVersion('');
        return;
      }

      setLocalStorageItem('appVersion', text.trim());
      setAppVersion(text.trim());
    } catch (error) {
      console.error('Version fetch failed:', error);
      setAppVersion('');
    }
  };

  useEffect(() => {
    handleVersion();
  }, []);

  useEffect(() => {
    const domain = getFirstSubdomain();
    if (deviceId && domain?.toLowerCase() !== 'saqr-tech') {
      window.location.href = `${config.deepLink}/${deviceId}`;
    }
  }, []);
  console.log('cachedLocal', cachedLocal);

  return (
    <div className="component-loader-wrap">
      <ToastMessage
        open={toastStatus.openToast}
        onClose={() =>
          setToastStatus({
            openToast: false,
            showToastMessage: '',
          })
        }
        type="error"
        message={toastStatus.showToastMessage || t('toastSomethingWrong')}
        onCloseTimer={6000}
      />

      <div className="charging-instruction-wrap">
        <div className="navbar-container">
          <img
            src={brandImage.logo}
            alt=""
            className={`navbar-logo ${brandData?.clientName === 'saqr-tech' ? 'saqr-tech' : ''}`}
          />
          <LanguageSelector />
        </div>
        <div className="charging-instruction">
          <h3 className="steps">{t('step1')}</h3>
          <p className="detail">{t('step1Desc')}</p>
          <h3 className="steps">{t('step2')}</h3>
          <p className="detail">{t('step2Desc')}</p>
          <h3 className="steps">{t('step3')}</h3>
          <p className="detail">{t('step3Desc')}</p>
          <h3 className="steps">{t('step4')}</h3>
          <p className="detail">{t('step4Desc')}</p>
          <h3 className="steps">{t('step5')}</h3>
          <p className="detail">{t('step5Desc')}</p>
          <MyButton label={t('startBtn')} buttonType="submit" onClickFunc={handleRoute} />
          <div className={brandData?.footer ? 'app-version' : 'app-version-only'}>
            {brandData?.footer && <Footer />}
            <span>{appVersion}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
